import React from "react";
import PropTypes from "prop-types";

/**
 * ErrorBoundary
 */
class ErrorBoundary extends React.Component {
  static propTypes = {
    children: PropTypes.node
  };

  static defaultProps = {
    children: null
  };

  state = {
    error: null
  };

  componentDidCatch(error, errorInfo) {
    this.setState({ error });
    if (process.env.NODE_ENV === "production" && window.Raven) {
      window.Raven.captureException(error, { extra: errorInfo });
    }
  }

  render() {
    if (this.state.error) {
      // eslint-disable-next-line no-console,no-unused-expressions
      console.error && console.error(this.state.error);
      return null;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
